module.exports = __webpack_public_path__ + "assets/images/project/map-logo-bak/map-logo-desktop.jpg?v=9fabe024";